import {
  CSSObject, Components, Theme, toggleButtonClasses,
} from '@mui/material';
import { label3 } from '../typography/jscss';
import { makePadding, MuiButton as muiButtonTheme } from '../button/theme';
import { Focused, Disabled, Secondary } from '../color';
import { toggleButtonGroupClasses } from './types';
import { buttonClasses } from '../button';
import { Corners } from '../corners/tokens';
import getTransition from '../utilities/getTransition';

const secondaryButton = muiButtonTheme!.styleOverrides!.containedSecondary! as CSSObject;
const textButton = muiButtonTheme!.styleOverrides!.textSecondary! as CSSObject;

export const MuiToggleButton: Components<Theme>['MuiToggleButton'] = {
  styleOverrides: {
    root: ({ ownerState }) => ({
      border: 0,
      borderRadius: Corners.large,
      padding: makePadding(ownerState.size),
      ...getTransition(['background-color']),
      ':focus-visible': {
        outlineColor: Focused.main,
        outlineStyle: 'solid',
        outlineWidth: 2,
        outlineOffset: 1,
        boxShadow: 'none',
        zIndex: 1,
      },
      [`&.${buttonClasses.disabled}`]: {
        border: 0,
        backgroundColor: Disabled.default.main,
      },
    }),
    sizeExtraSmall: {
      minWidth: 44,
      fontSize: label3.fontSize,
      lineHeight: label3.lineHeight,
      borderRadius: 6,
    },

  },
};

export const MuiToggleButtonGroup: Components<Theme>['MuiToggleButtonGroup'] = {
  styleOverrides: {
    root: {
      borderRadius: Corners.large,
      border: 0,
      [`&.${buttonClasses.disabled}`]: {
        border: 0,
      },
      [`&.${toggleButtonGroupClasses.colorVariantTonal} .${toggleButtonClasses.root}`]: {
        ...secondaryButton,
        ...getTransition(['background-color']),

        [`&.${buttonClasses.disabled}, &.${buttonClasses.disabled}.${buttonClasses.selected}`]: {
          color: Disabled.default.text,
          backgroundColor: Disabled.default.main,
        },
      },
      [`&.${toggleButtonGroupClasses.colorVariantText} .${toggleButtonClasses.root}`]: {
        ...textButton,
        ...getTransition(['background-color']),
        color: Secondary.container.text,

        [`&.${buttonClasses.selected}`]: {
          backgroundColor: Secondary.surface.selected,
        },
        [`&.${buttonClasses.disabled}, &.${buttonClasses.disabled}.${buttonClasses.selected}`]: {
          color: Disabled.default.text,
          backgroundColor: Disabled.default.main,
        },
      },
      [`&.${toggleButtonGroupClasses.colorVariantStrong} .${toggleButtonClasses.root}`]: {
        ...getTransition(['background-color']),
        ...secondaryButton,

        [`&.${buttonClasses.selected}`]: {
          backgroundColor: Secondary.default.selected,
          color: Secondary.default.text,
          '&:active': {
            backgroundColor: Secondary.default.pressed,
          },
        },

        [`&.${buttonClasses.disabled}, &.${buttonClasses.disabled}.${buttonClasses.selected}`]: {
          color: Disabled.default.text,
          backgroundColor: Disabled.default.main,
        },
      },
    },
    firstButton: {
      marginRight: 1,
      border: 0,
      [`&.${buttonClasses.disabled}`]: {
        border: 0,
      },
    },
    middleButton: {
      marginLeft: 0,
      marginRight: 1,
      border: 0,
      [`&.${buttonClasses.disabled}`]: {
        border: 0,
      },
    },
    lastButton: {
      marginLeft: 0,
      border: 0,
      [`&.${buttonClasses.disabled}`]: {
        border: 0,
      },
    },
  },
};
